import React, { useState, useEffect, useContext } from "react";
import { C4FStatusContext, INIT_STATUS_COMPLETED, ReferenceDataContext } from "./App";
import config from "../etc/config.json";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import moment from 'moment';
import '../css/general.css';
import { isCustomTourJersey } from "../race/C4FLeaderJerseys";
import { getUnicodeOrImageFlag } from "../common/Helpers";
import releaseNotes from "./ReleaseNotes.json";
import packageJson from '../../package.json';


function Start(props) {
  const { initialized, handleBackendRequest, browserInfo } = useContext(C4FStatusContext);
  const { countries } = useContext(ReferenceDataContext);
  const [generalInformation, setGeneralInformation] = useState(null);
  const [raceEditions, setRaceEditions] = useState([]);

  function loadRaceEditions() {
    handleBackendRequest('GET', '/raceEdition', null, { context: 'today' }, setRaceEditions);
  }

  function todaysStage(currentStage, numberOfStages) {
    if (currentStage < 2) {
      return 1;
    }
    else if (currentStage > numberOfStages) {
      return numberOfStages;
    }
    else if (currentStage <= numberOfStages) {
      return currentStage;
    }
    else {
      return 0;
    }
  }

  useEffect(() => {
    handleBackendRequest('GET', '/generalInformation', null, null, setGeneralInformation);
    loadRaceEditions();
  }, []);

  if (generalInformation !== null && initialized === INIT_STATUS_COMPLETED)
    return <div className="container-fluid m-0 p-0 justify-content-center">
      <div className="row d-flex mt-1 p-1 justify-content-center">
        <div className="col m-1 justify-content-center" style={{ minWidth: 400, maxWidth: "80vw", maxHeight: 540, overflow: "auto", textAlign: "center" }}>
          <br />
          {raceEditions.length > 0 && isCustomTourJersey('recurringEvent' in raceEditions[0].race ? raceEditions[0].race.recurringEvent : raceEditions[0].race.raceName) ?
            <>
              <img src={config.DIR_JERSEYS + config.SUBDIR_LEADERJERSEYS + ('recurringEvent' in raceEditions[0].race ? raceEditions[0].race.recurringEvent : raceEditions[0].race.raceName) + '_Youth.png'} height="70"></img>
              <img src={config.DIR_JERSEYS + config.SUBDIR_LEADERJERSEYS + ('recurringEvent' in raceEditions[0].race ? raceEditions[0].race.recurringEvent : raceEditions[0].race.raceName) + '_Mountain.png'} height="70"></img>
              <img src={config.DIR_JERSEYS + config.SUBDIR_LEADERJERSEYS + ('recurringEvent' in raceEditions[0].race ? raceEditions[0].race.recurringEvent : raceEditions[0].race.raceName) + '_Sprint.png'} height="70"></img>
              <img src={config.DIR_JERSEYS + config.SUBDIR_LEADERJERSEYS + ('recurringEvent' in raceEditions[0].race ? raceEditions[0].race.recurringEvent : raceEditions[0].race.raceName) + '_GCLeader.png'} height="70"></img>
            </>
            :
            <>
              <img src={config.DIR_JERSEYS + config.SUBDIR_LEADERJERSEYS + 'Standard_Youth.png'} height="70"></img>
              <img src={config.DIR_JERSEYS + config.SUBDIR_LEADERJERSEYS + 'Standard_Mountain.png'} height="70"></img>
              <img src={config.DIR_JERSEYS + config.SUBDIR_LEADERJERSEYS + 'Standard_Sprint.png'} height="70"></img>
              <img src={config.DIR_JERSEYS + config.SUBDIR_LEADERJERSEYS + 'Standard_GCLeader.png'} height="70"></img>
            </>
          }
          <br />
          <br />
          <b>Cycling4Freaks - the #1 Cycling Manager</b> <br />
          All races live! Against real opponents! <br />
          Day after day the real cycling calendar! <br />
          Build your team and lead it to victory!<br />
          <br />
          C4F is a <b>fair, balanced play-to-win</b> game.<br />
          The game is privately run and non-commercial (no ads).<br /><br />
          Sign up today, receive <b>20,000,000 start budget</b> and <b>play for free!</b><br />
          <Link to="/signup" className="btn btn btn-success mt-2 px-3">Sign Up</Link><br />
          <br />
          <b>Already have an account?</b><br />
          <Link to="/login" className="btn btn-primary mt-2 px-4">Login</Link><br />
          <p>{packageJson.name} {packageJson.version}</p>
          <br />
        </div>
        <div className="col p-0 m-1" style={{ minWidth: 200, maxWidth: 350 }}>
          <h5 className="ml-2 text-left"><u>C4F News</u></h5>
          <div className="border border-secondary p-1 m-0" style={{ maxHeight: 480, minWidth: 200, maxWidth: 350, overflow: "auto", backgroundColor: 'rgba(251, 253, 255, 1)' }}>
            {generalInformation.news.map(news =>
              <div>
                <p className="ml-2 mt-1 mb-0 text-left" style={{ color: "#c61c18", padding: 0, marginBottom: "0px" }}>
                  {moment(news.date).format('dd, D MMM YYYY')}
                </p>
                <p className="ml-2 mt-1 mb-0 pb-3 text-left" style={{ wordBreak: "break-word", padding: 0, marginBottom: "0px" }}>
                  {news.message}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="row d-flex mt-1 p-1 justify-content-center">
        <div className="col ml-2 mr-1 my-1 p-0" style={{ minWidth: 400, maxWidth: "80vw" }}>
          <h5><u>Today's Races</u></h5>
          <div className="m-0 p-0" style={{ maxHeight: 400, minWidth: 400, maxWidth: "80vw", overflow: "auto", backgroundColor: 'rgba(245, 250, 255, 1)' }}>
            <table className="table table-sm table-striped">
              <thead>
                <tr>
                  <th className="th-infotable" scope="col" style={{ textAlign: "left" }}>Start</th>
                  <th className="th-infotable" scope="col" style={{ textAlign: "left" }}>Race</th>
                  <th className="th-infotable" scope="col">Day</th>
                  <th className="th-infotable" scope="col">Cat.</th>
                  <th className="th-infotable" scope="col">Teams</th>
                </tr>
              </thead>
              <tbody className="text-center">
                {raceEditions
                  .sort(function (a, b) { return a.startingTime - b.startingTime })
                  .map((raceEdition) => (
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>{raceEdition.startingTime}:00 CET</td>
                      <td className="td-infotable" style={{ textAlign: "left" }}>
                        {getUnicodeOrImageFlag(countries, raceEdition.race.country, browserInfo)}&nbsp;{raceEdition.race.raceName}</td>
                      <td className="td-infotable">{todaysStage(raceEdition.currentStage, raceEdition.race.numberOfStages)} / {raceEdition.race.numberOfStages}</td>
                      <td className="td-infotable">{raceEdition.race.category}</td>
                      <td className="td-infotable">{raceEdition.numberOfParticipants}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="col p-0 m-1" style={{ minWidth: 200, maxWidth: 350 }}>
          <h5 className="ml-2 text-left"><u>Recent Race Results</u></h5>
          <div className="border border-secondary p-1 m-0" style={{ maxHeight: 300, minWidth: 200, maxWidth: 350, overflow: "auto", backgroundColor: 'rgba(251, 253, 255, 1)' }}>
            {generalInformation.results.map(result =>
              result.message.split('\n').map(line =>
                <span >{line}<br /></span>
              )
            )}
          </div>
        </div>
      </div>
      <Row flex className="mt-1 p-1 justify-content-left">
        <Col className="mt-1 justify-content-left border-top border-grey" style={{ textAlign: "left" }}>
          <h5 className="ml-2 text-left"><u>Version Control</u></h5>
          <div className="m-0 p-2" style={{ maxHeight: 500, minWidth: 400, maxWidth: "80vw", overflow: "auto", backgroundColor: 'rgba(245, 250, 255, 1)' }}>
            {releaseNotes.slice(0, 6).map(item => 
           <>
            <h5>{packageJson.name} {item.version}</h5>
            Latest Updates ({item.date})
            <ul>
              {item.changes.map(change => <li>{change}</li>)}
            </ul>
           </>   
              )}
          </div>
        </Col>
      </Row>
    </div>
  else return null;
}
export default Start;
